import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export type FetchExistingMappingsAction = Request.RequestAction
export type FetchExistingMappings =
  (communityIdentifier: string, communitySystemId: Types.CommunitySystemId) => FetchExistingMappingsAction

export const fetchExistingMappings: FetchExistingMappings = (communityIdentifier, communitySystemId) =>
  Request.integrationsRequestActionCreator(Constants.FETCH_EXISTING_MAPPINGS)
  ({
    method: 'GET',
    url: `/${communityIdentifier}/existing-mappings/${communitySystemId}`,
  })



// WEBPACK FOOTER //
// ./src/pages/integration-mappings/actions.ts